module.exports = __webpack_public_path__ + "img/logo.3aeb9c0a.svg";